import { canonicalizeBcp47Locale } from '@/lib/locale';

export const EU_APP_LOCALES = [
  'bg-BG',
  'hr-HR',
  'cs-CZ',
  'da-DK',
  'nl-NL',
  'en',
  'et-EE',
  'fi-FI',
  'fr-FR',
  'de-DE',
  'el-GR',
  'hu-HU',
  'ga-IE',
  'it-IT',
  'lv-LV',
  'lt-LT',
  'mt-MT',
  'pl-PL',
  'pt-PT',
  'ro-RO',
  'sk-SK',
  'sl-SI',
  'es-ES',
  'sv-SE',
] as const;

export type EuAppLocale = (typeof EU_APP_LOCALES)[number];
type PrimaryLanguage<Locale extends string> = Locale extends `${infer Language}-${string}`
  ? Language
  : Locale;
export type EuAppLanguage = PrimaryLanguage<EuAppLocale>;

export function resolveRequestedAppLocale(
  configuredLocale: string | null | undefined,
  browserLocale: string | null | undefined,
): string {
  return (
    (configuredLocale ? canonicalizeBcp47Locale(configuredLocale) : null) ??
    (browserLocale ? canonicalizeBcp47Locale(browserLocale) : null) ??
    'en'
  );
}

export function localeLanguage(locale: string | null | undefined): string {
  try {
    return new Intl.Locale(locale || 'en').language;
  } catch {
    return 'en';
  }
}
